import { render, staticRenderFns } from "./GeneralEditText.vue?vue&type=template&id=507bad21&scoped=true&"
import script from "./GeneralEditText.vue?vue&type=script&lang=js&"
export * from "./GeneralEditText.vue?vue&type=script&lang=js&"
import style0 from "./GeneralEditText.vue?vue&type=style&index=0&id=507bad21&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507bad21",
  null
  
)

export default component.exports